import { Inject, Injectable, InjectionToken } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, share } from 'rxjs/operators';

import { GasBrowserEvents } from './gas-browsers-events.namespace';

const DELAY_TIME = 200;

/**
 * Сервис предназначен для отлавливания глобальных событий
 * Таких как, scroll и resize окна
 * Используйте данный сервис, вместо того, что бы вручную подписываться каждый раз
 *
 * Пример:
 *
 * @example gasBrowserEventsService.scroll.subscribe((event: Event) => console.log('handle event ' + event));
 */
@Injectable({
  providedIn: 'root',
})
export class GasBrowserEventsService implements GasBrowserEvents.ServiceInterface {
  public readonly scroll$: Observable<Event> = fromEvent(window, 'scroll');
  public readonly resize$: Observable<Event> = fromEvent(window, 'resize');
  public readonly delayScroll$: Observable<Event> = this.delayed(this.scroll$);
  public readonly delayResize$: Observable<Event> = this.delayed(this.resize$);

  private delayed<T>(observable: Observable<T>): Observable<T> {
    return observable.pipe(
      debounceTime(DELAY_TIME),
      share(),
    );
  }
}
